import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { PartOptionCupiCode } from '../../../interfaces/Case';
import * as R from 'ramda';

interface IPartOptionCupiCodeState {
  newPartOptionCupiCode: PartOptionCupiCode;
  partOptionList: IReferential[];
  partOptionCupiCodeList: PartOptionCupiCode[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newPartOptionCupiCodeId: number | null;
  countryList: IReferential[];
}

type IPartOptionCupiCodeProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;

class PartOptionCupiCodeComponent extends React.PureComponent<
  IPartOptionCupiCodeProps,
  IPartOptionCupiCodeState
> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appReferentialService!: IReferentialService;


  static contextType = ApplicationContext;
  private newPartOptionCupiCode = {
    id: 0,
    partOptionId: 0,
    cupiCode: null,
    countryId: null
  } as unknown as PartOptionCupiCode;

  state = {
    partOptionCupiCodeList: [],
    isLoading: false,
    selectedFilter: 0,
    isDialogOpen: false,
    newPartOptionCupiCode: this.newPartOptionCupiCode,
    partOptionList: [],
    newPartOptionCupiCodeId: null,
    countryList: []
  } as IPartOptionCupiCodeState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadPartOptionCupiCodeList();
      }
    );
  }

  loadPartOptionCupiCodeList = async () => {
    const partOptionCupiCodeList = await this.caseService.PartOptionCupiCodeList();
    const ref = Referentials.referential.find(
      (item) => item.code === ReferentialCode.PartOption
    );
    const countryRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.Country
    );
    const [partOptionList, countryList] = await Promise.all([
      this.appReferentialService.Get(ref!.baseUrl),
      this.appReferentialService.Get(countryRef!.baseUrl)
    ]);

    partOptionCupiCodeList.forEach(item => {
      const country = countryList.find(countryItem => !R.isNil(item.partOption) && countryItem.id === item.partOption.dependencyId);
      item.country = R.isNil(country) ? null : country;
    });  
    
    this.setState({
      partOptionCupiCodeList: partOptionCupiCodeList,
      isLoading: false,
      partOptionList: partOptionList.filter((item) => item.isActive === true),
      countryList: countryList.filter((item) => item.isActive === true),
      newPartOptionCupiCode: { ...this.newPartOptionCupiCode }
    });
  };


  private handlePartOptionChange = (newValue: IReferential | null) => {
    this.setState({
      newPartOptionCupiCode: {
        ...this.state.newPartOptionCupiCode,
        partOption: newValue,
        partOptionId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleCountryChange = (newValue: IReferential | null) => {
    this.setState({
      newPartOptionCupiCode: {
        ...this.state.newPartOptionCupiCode,
        country: newValue,
        countryId: newValue !== null ? newValue!.id : 0,
      }
    });
  };

  private handleCupiCodeChange = (value: string) => {
    this.setState({
      newPartOptionCupiCode: {
        ...this.state.newPartOptionCupiCode,
        cupiCode: value
      }
    });
  };

  public savePartOptionCupiCode = async () => {
    if (this.state.newPartOptionCupiCodeId === null) {
      try {

        await this.caseService.AddPartOptionCupiCode(this.state.newPartOptionCupiCode);

        await this.loadPartOptionCupiCodeList();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {

        await this.caseService.UpdatePartOptionCupiCode(this.state.newPartOptionCupiCode);

        await this.loadPartOptionCupiCodeList();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  private getPartOptions(): IReferential[] {
    const filteredPartOptions = this.state.partOptionList.filter(
      (partOption) => (this.state.newPartOptionCupiCode.countryId && partOption.dependencyId) && partOption.dependencyId === this.state.newPartOptionCupiCode.countryId
    );

    return filteredPartOptions || [];
  }

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.savePartOptionCupiCode} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="country"
            fullWidth
            options={this.state.countryList}
            value={this.state.newPartOptionCupiCode.country}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleCountryChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="country"
                value={this.state.newPartOptionCupiCode.country || ''}
                label={this.translatorService.Tranlate(
                  'EDIT_ORGANIZATION_COUNTRY_LABEL',
                  'Tara'
                )}
                fullWidth
                validators={[]}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="partOption"
            fullWidth
            options={this.getPartOptions()}
            value={this.state.newPartOptionCupiCode.partOption}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handlePartOptionChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="partOption"
                value={this.state.newPartOptionCupiCode.partOption}
                label={this.translatorService.Tranlate(
                  'MAINTENANCE_CUPI_PART_OPTIONAL_NAME',
                  'Denumire Piesa'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="cupiCode"
            id="cupiCode"
            value={this.state.newPartOptionCupiCode.cupiCode || ''}
            onChange={(e: any) => this.handleCupiCodeChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'MAINTENANCE_CUPI_PART_OPTIONAL_CUPI_CODE',
              'Cod Cupi'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'country',
        label: this.translatorService.Tranlate(
          'EDIT_ORGANIZATION_COUNTRY_LABEL',
          'Tara'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.displayName?.localeCompare(b.displayName!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'partOption',
        label: this.translatorService.Tranlate(
          'MAINTENANCE_CUPI_PART_OPTIONAL_NAME',
          'Denumire Piesa'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.displayName?.localeCompare(b.displayName!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'cupiCode',
        label: this.translatorService.Tranlate('MAINTENANCE_CUPI_PART_OPTIONAL_CUPI_CODE', 'Cod Cupi')
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newPartOptionCupiCodePopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deletPartOptionCupiCode(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];

    return columns;
  };

  deletPartOptionCupiCode = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.caseService.RemovePartOptionCupiCode(id);
      await this.loadPartOptionCupiCodeList();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };


  newPartOptionCupiCodePopup = async (partOptionCupiCodeId: number | null) => {
    let newPartOptionCupiCode: PartOptionCupiCode;
    if (partOptionCupiCodeId == null) {
      newPartOptionCupiCode = { ...this.state.newPartOptionCupiCode } as PartOptionCupiCode;
    } else {
      newPartOptionCupiCode = this.state.partOptionCupiCodeList.find((item) => item.id === partOptionCupiCodeId)!;
    }
    this.setState({
      isDialogOpen: true,
      newPartOptionCupiCode: newPartOptionCupiCode,
      newPartOptionCupiCodeId: partOptionCupiCodeId
    });
  };

  closeDialog = async () => {
    this.setState(
        { 
          isDialogOpen: false, 
          newPartOptionCupiCode: this.newPartOptionCupiCode 
        }
      );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newPartOptionCupiCodePopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };

    return (
      <Fragment>
    
       <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.partOptionCupiCodeList}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                  {!this.state.newPartOptionCupiCodeId ? 
                    this.translatorService.Tranlate(
                      'MAINTENANCE_CUPI_PART_OPTIONAL_ADD_MODAL_TITLE',
                      'Adauga Cod Cupi'
                    ) : this.translatorService.Tranlate(
                      'MAINTENANCE_CUPI_PART_OPTIONAL_UPDATE_MODAL_TITLE',
                      'Actualizeaza Cod Cupi'
                    )}               
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>) : null}
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(PartOptionCupiCodeComponent as any));
